module.exports = __webpack_public_path__ + "static/media/Location_Book-Page27.b4cf306f.png";